import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Card,
  Table,
  Button,
  Select,
  Input,
  Tooltip,
  Collapse,
  message,
  Modal,
} from "antd";
import storageUtils from "../../utils/storageUtils";
import { usrRole } from "../../utils/dataUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import {
  req_page_pim_flexible_group_staff,
  req_add_pim_flexible_group_staff,
  req_del_pim_flexible_group_staff,
  req_single_people,
} from "../../api";
import GroupStaffImportModal from "./group-staff-import-modal";

const { Panel } = Collapse;
class FlexibleLogGroupStaffModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    staff: {},
    staffCode: "",
    staffName: "",
    domnloadFile: "",
    isShowModal: false,
    isUploadModal: false,
    singleAddBtnStatus: true,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    //console.log(this.props.data);
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    const { Id } = this.props.data;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true });
    const result = await req_page_pim_flexible_group_staff(
      userCode,
      userLevel,
      Id,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_search_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_single_people(key, token);
    //console.log(result);
    if (result === null) {
      message.success("查無此人");
      this.setState({
        staff: {},
        staffCode: "",
        staffName: "",
        singleAddBtnStatus: true,
      });
    } else {
      this.setState({
        staff: result,
        staffCode: result.EmployeeId,
        staffName: result.TwName,
        singleAddBtnStatus: false,
      });
    }
  };

  api_modify_item = async (item) => {
    const result = await req_add_pim_flexible_group_staff(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      this.setState({
        staff: {},
        staffCode: "",
        staffName: "",
        singleAddBtnStatus: true,
      });
      this.handle_data_refresh();
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_del_pim_flexible_group_staff(key, token);

    if (result.status === "success") {
      this.handle_data_refresh();
    } else {
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: "50px",
        align: "center",
        fixed: "true",
        render: (item) => {
          return (
            <>
              {" "}
              <button
                className="btn btn-danger btn-sm"
                onClick={() => this.handle_btn_del(item)}
              >
                <i className="fas fa-user-alt-slash"></i> 刪除
              </button>
            </>
          );
        },
      },
      {
        title: "職號",
        dataIndex: "StaffCode",
        width: 100,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "StaffName",
        width: 100,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        const { staffCode, staffName } = this.state;
        if (staffName === "") {
          message.error("請輸入正確職號");
        } else {
          const item = {
            GroupId: this.props.data.Id,
            StaffCode: staffCode,
            StaffName: staffName,
            OperatorCode: storageUtils.getUser().userCode,
          };
          this.api_modify_item(item);
        }
        break;
      case "addYLabor":
        const itemY = {
          GroupId: this.props.data.Id,
          OperatorCode: storageUtils.getUser().userCode,
          condition: "Y_LABOR",
        };
        this.api_modify_item(itemY);
        break;
      case "addNLabor":
        const itemN = {
          GroupId: this.props.data.Id,
          OperatorCode: storageUtils.getUser().userCode,
          condition: "N_LABOR",
        };
        this.api_modify_item(itemN);
        break;
      case "import":
        this.setState({ isUploadModal: true });
        break;
      case "download":
        break;
      default:
    }
  };

  handleStaffCodeChange = (event) => {
    if (event.target.value.length === 6) {
      this.api_search_item(event.target.value);
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
  };

  handle_btn_del = (item) => {
    const { Uid } = item;
    Modal.confirm({
      title: `您確定刪除此筆資料嗎?`,
      onOk: () => {
        this.api_delete_item(Uid);
      },
    });
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      staffName,
      isUploadModal,
    } = this.state;
    const title = (
      <>
        <div style={{ marginBottom: "4px" }}>
          {" "}
          <Select
            value={searchField}
            style={{ width: 120 }}
            onChange={(value) => this.setState({ searchField: value })}
          >
            <Select.Option value="NONE">搜索條件</Select.Option>
            <Select.Option value="StaffName">姓名</Select.Option>
            <Select.Option value="StaffCode">職號</Select.Option>
          </Select>
          <Input
            placeholder="關鍵字"
            style={{ width: 100, margin: "0 5px" }}
            value={searchValue}
            onChange={(event) =>
              this.setState({ searchValue: event.target.value })
            }
          />
          <Button type="primary" onClick={() => this.api_page_items(1)}>
            <i className="fas fa-search element-hidden"></i>
            <span style={{ marginLeft: "4px" }}>查詢</span>
          </Button>{" "}
          <Tooltip placement="top" title="重新整理">
            <Button type="primary" onClick={() => this.handle_data_refresh()}>
              <i className="fas fa-sync-alt"></i>
            </Button>
          </Tooltip>
        </div>

        <Collapse>
          <Panel header="新增單筆資料" key="1">
            <>
              <form className="form-inline">
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow", width: "120px" }}
                  name="StaffCode"
                  id="StaffCode"
                  placeholder="請輸入職號"
                  onChange={this.handleStaffCodeChange}
                />
                <input
                  type="text"
                  disabled={true}
                  value={staffName}
                  style={{ marginRight: "5px" }}
                  className="form-control text-primary"
                  name="StaffName"
                  id="StaffName"
                />
                <Button
                  type="primary"
                  disabled={this.state.singleAddBtnStatus}
                  onClick={() => this.handle_show_ui_modal("add", {})}
                >
                  <i className="fas fa-plus"></i>
                  <span style={{ marginLeft: "4px" }}>單筆增加</span>
                </Button>
              </form>
            </>
          </Panel>
          <Panel header="新增多筆資料" key="2">
            <>
              <Button
                type="primary"
                onClick={() => this.handle_show_ui_modal("addYLabor", {})}
              >
                <i className="fas fa-plus"></i>
                <span style={{ marginLeft: "4px" }}>一鍵增適用勞基法人員</span>
              </Button>{" "}
              <Button
                type="primary"
                onClick={() => this.handle_show_ui_modal("addNLabor", {})}
              >
                <i className="fas fa-plus"></i>
                <span style={{ marginLeft: "4px" }}>
                  一鍵增 非 適用勞基法人員
                </span>
              </Button>{" "}
              <Button
                onClick={() => this.handle_show_ui_modal("import", {})}
                danger
              >
                <i className="fas fa-plus"></i>
                <span style={{ marginLeft: "4px" }}>匯入檔案</span>
              </Button>
            </>
          </Panel>
        </Collapse>
      </>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isUploadModal}
          width={300}
          onOk={() => {
            this.setState({ isUploadModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isUploadModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <GroupStaffImportModal
            data={this.props.data}
            creator={this.props.user}
          />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(FlexibleLogGroupStaffModal);
